import React from 'react';

const DataSizeIcon = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.8125 13.5625V7.4375H2.1875L7.65625 2.1875L13.125 7.4375H10.5V13.5625H4.8125V13.5625Z" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M16.1875 7.4375V13.5625H18.8125L13.3438 18.8125L7.875 13.5625H10.5V7.4375H16.1875V7.4375Z" stroke="#282828" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default DataSizeIcon;